module.exports = __webpack_public_path__ + "static/img/female-bg-es.1c21121a.png";